import React from 'react';
import { RecruiterCandidate, RecruiterEvaluation, RecruiterInterview } from '../../../../types/recruiter';

interface SummaryProps {
  selectedInterview: RecruiterInterview;
  selectedCandidate: RecruiterCandidate;
  evaluation?: RecruiterEvaluation;
  totalScore: number;
}

export const Summary: React.FC<SummaryProps> = ({
  selectedInterview,
  selectedCandidate,
  evaluation,
  totalScore,
}) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-lg font-semibold text-gray-900">
          {selectedInterview.type} - 詳細情報
        </h4>
        {evaluation && (
          <div className="text-right">
            <div className="text-xl font-bold text-gray-900">{totalScore}~点</div>
          </div>
        )}
      </div>

      {/* 詳細評価テキスト */}
      {evaluation && (evaluation.summary || (evaluation as any).detailedFeedback || (evaluation as any).evaluationText) && (
        <div className="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-200 mb-6">
          <h5 className="font-medium text-gray-900 mb-3">詳細評価</h5>
          <div className="text-gray-700 leading-relaxed whitespace-pre-line">
            {evaluation.summary || (evaluation as any).detailedFeedback || (evaluation as any).evaluationText}
          </div>
        </div>
      )}

      <div className="text-sm text-gray-600 mb-4">
        面接完了日時: {selectedInterview.completedAt
          ? new Date(selectedInterview.completedAt).toLocaleString('ja-JP', {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })
          : '-'} | 面接タイトル: {selectedInterview.type}
      </div>

      {/* 経歴サマリー */}
      <div className="mb-6">
        <h5 className="font-medium text-gray-900 mb-3">経歴サマリー</h5>
        {selectedCandidate.careerSummary ? (
          <div className="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-200">
            <div className="text-gray-700 leading-relaxed whitespace-pre-line">
              {selectedCandidate.careerSummary}
            </div>
          </div>
        ) : (
          <div className="bg-gray-50 rounded-lg p-4 text-center">
            <div className="text-gray-500 text-sm">
              経歴サマリーはまだ生成されていません。
              <br />
              AI面接後に自動生成されます。
            </div>
          </div>
        )}
      </div>

    </div>
  );
};
